<div class="flex items-center space-x-2 text-sm">
  <label for="pageSelect" class="text-gray-600 font-bold">Page:</label>
  <select
    id="pageSelect"
    class="border border-gray-300 rounded-md px-2 py-1"
    [value]="currentPage"
    (change)="onPageChange($event)"
    >
    @for (page of pages; track page) {
      <option [value]="page">
        {{ page }}
      </option>
    }
  </select>
  <span class="text-gray-600 font-bold">of {{ totalPages }}</span>
</div>
